import { useTranslate } from 'react-admin'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { Grid } from '@mui/material'

export const AssistanceTab = ({ product, loading }) => {
  const translate = useTranslate()
  return (
    <Grid container spacing={2}>
      <ShowListElement
        label={translate('ra.field.route_type')}
        value={product?.route_type}
        loading={loading}
      />
    </Grid>
  )
}
